<div class="usuario-card">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">
        <i class="fas fa-user-circle"></i> Información del Usuario
      </h3>
    </div>
    <div class="card-body">
      <div class="usuario-content" [class.with-estudiante]="user.nroLibreta">
        <!-- User Information Section -->
        <div class="user-info-section">
          <div class="info-group">
            <label><i class="fas fa-user"></i> Usuario</label>
            <p class="info-value">{{ user.username }}</p>
          </div>

          <div class="info-group">
            <label><i class="fas fa-envelope"></i> Email</label>
            <p class="info-value">{{ user.email }}</p>
          </div>

          <div class="info-group">
            <label><i class="fas fa-shield-alt"></i> Permisos</label>
            <p class="info-value">
              <span class="badge" [ngClass]="getRoleClass(user.role)">
                {{ getRoleDisplay(user.role) }}
              </span>
            </p>
          </div>

          <div class="info-group">
            <label><i class="fas fa-calendar-plus"></i> Creado</label>
            <p class="info-value">{{ formatDate(user.createdAt) }}</p>
          </div>

          <div class="info-group" *ngIf="user.nroLibreta">
            <label><i class="fas fa-id-card"></i> Nro Libreta</label>
            <p class="info-value">{{ user.nroLibreta }}</p>
          </div>

          <!-- Action Buttons -->
          <div class="action-buttons">
            <button class="btn btn-primary" routerLink="/cambiar-password">
              <i class="fas fa-key"></i> Cambiar Contraseña
            </button>
          </div>
        </div>

        <!-- Estudiante Card Section (if exists) -->
        <div class="estudiante-section" *ngIf="user.nroLibreta">
          <h4 class="estudiante-title">
            <i class="fas fa-graduation-cap"></i> Datos del Estudiante
          </h4>
          
          <div *ngIf="loadingEstudiante" class="loading-spinner">
            <i class="fas fa-spinner fa-spin"></i>
            <p>Cargando...</p>
          </div>

          <div *ngIf="errorLoadingEstudiante && !loadingEstudiante" class="alert alert-warning">
            <i class="fas fa-exclamation-triangle"></i>
            No se pudieron cargar los datos del estudiante.
          </div>

          <div *ngIf="estudiante && !loadingEstudiante" class="estudiante-card-wrapper">
            <app-estudiante-card 
              [estudiante]="estudiante"
              (viewDetail)="onViewEstudianteDetail($event)">
            </app-estudiante-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>